import { Tooltip } from '@/components/ui/tooltip/Tooltip'
import { useIsTouchOnlyDevice } from '@/hooks/useIsTouchOnlyDevice'

export type SideNavRailTooltipProps = {
  /** The item's name, shown to the right of the rail */
  title: string
  children: React.ReactElement
}

/**
 * The hover tooltip naming an icon-only rail item, skipped on touch-only devices as IconButton does.
 *
 * On touch `Tooltip` wraps its child in a full-width tap-to-open `span`, which left-aligns the 36px
 * item in the 48px rail and gives every destination a second tab stop and button role.
 */
export function SideNavRailTooltip({ title, children }: SideNavRailTooltipProps) {
  const isTouchOnly = useIsTouchOnlyDevice()

  if (isTouchOnly) return children

  return (
    <Tooltip title={title} placement="right">
      {children}
    </Tooltip>
  )
}
